(() => {
  const footer = document.querySelector("[data-footer]");
  if (!footer) return;

  const cols = footer.querySelectorAll("[data-footer-col]");
  const mobileQuery = window.matchMedia("(max-width: 768px)");

  function expandCol(col) {
    const toggle = col.querySelector("[data-footer-col-toggle]");
    const collapse = col.querySelector(".footer__collapse");
    if (!collapse) return;

    collapse.hidden = false;
    col.classList.add("is-open");
    if (toggle) toggle.setAttribute("aria-expanded", "true");
  }

  function collapseCol(col) {
    const toggle = col.querySelector("[data-footer-col-toggle]");
    const collapse = col.querySelector(".footer__collapse");
    if (!collapse || !col.classList.contains("is-open")) return;

    col.classList.remove("is-open");
    if (toggle) toggle.setAttribute("aria-expanded", "false");

    collapse.addEventListener("transitionend", function onClose(event) {
      if (event.propertyName !== "grid-template-rows") return;

      if (!col.classList.contains("is-open")) {
        collapse.hidden = true;
      }

      collapse.removeEventListener("transitionend", onClose);
    });
  }

  function syncCols() {
    if (!mobileQuery.matches) {
      cols.forEach((col) => {
        const toggle = col.querySelector("[data-footer-col-toggle]");
        const collapse = col.querySelector(".footer__collapse");

        col.classList.remove("is-open");
        if (toggle) toggle.setAttribute("aria-expanded", "false");
        if (collapse) collapse.hidden = false;
      });
      return;
    }

    cols.forEach((col) => {
      if (col.hasAttribute("data-default-open")) {
        expandCol(col);
      } else {
        col.classList.remove("is-open");
        const toggle = col.querySelector("[data-footer-col-toggle]");
        const collapse = col.querySelector(".footer__collapse");
        if (toggle) toggle.setAttribute("aria-expanded", "false");
        if (collapse) collapse.hidden = true;
      }
    });
  }

  cols.forEach((col) => {
    const toggle = col.querySelector("[data-footer-col-toggle]");
    if (!toggle) return;

    toggle.addEventListener("click", () => {
      if (!mobileQuery.matches) return;

      if (col.classList.contains("is-open")) {
        collapseCol(col);
        return;
      }

      cols.forEach((openCol) => {
        if (openCol !== col && openCol.classList.contains("is-open")) {
          collapseCol(openCol);
        }
      });

      expandCol(col);
    });
  });

  syncCols();

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", syncCols);
  } else if (typeof mobileQuery.addListener === "function") {
    mobileQuery.addListener(syncCols);
  }
})();
